<template>
  <button
    class="size-8 bg-white rounded-full flex items-center justify-center text-xs cursor-pointer shadow-md lg:size-auto lg:h-8 lg:gap-1 lg:px-3 font-semibold"
    type="button"
    :disabled="!canReport"
    @click="handleReport"
  >
    ⚠️ <span class="hidden lg:block">report issue</span>
  </button>
</template>

<script setup lang="ts">
import type { Nullable } from '~/types'

type ReportPhoto = {
  Path?: Nullable<string>
}

const props = defineProps<{
  rvNumber: number
  photos?: Nullable<ReportPhoto[]>
  listingUrl?: Nullable<string>
}>()

const { getDynamicImage } = useImage()

const { isMasquerading } = useMasquerade()

const canReport = computed(() => Boolean(props.rvNumber) && isMasquerading.value)

const { addToast } = useToast()

async function handleReport() {
  if (!isMasquerading.value) {
    return
  }

  if (!canReport.value) {
    addToast({
      message: 'Unable to report photos: RV details are missing.',
      variant: 'danger',
    })
    return
  }

  try {
    await $fetch('/api/slack', {
      method: 'POST',
      body: {
        rvId: props.rvNumber,
        rvUrl: props.listingUrl,
        rvPhotos: props.photos?.map((photo) => getDynamicImage({ path: photo.Path })),
      },
    })

    addToast({
      message: 'Photos have been reported. Thank you!',
      variant: 'success',
    })
  }
  catch {
    addToast({
      message: 'Something went wrong while reporting photos. Please try again.',
      variant: 'danger',
    })
  }
}
</script>
